import React from "react";
import { Link } from "react-router-dom";
import { MdCake, MdCheckCircle, MdCancel, MdOutlineAlternateEmail } from "react-icons/md";
import { Col, Row } from "react-bootstrap";
import { BsFillTelephoneFill } from "react-icons/bs";
import { FaUser, FaHome } from "react-icons/fa";
import { IoMdOpen } from "react-icons/io";
import PhoneCallButton from '../components/task/calls/PhoneCallButton';

const PatientNotesContainer = ({patientNotes}) => {
  let arr = patientNotes.map((note) => {
    return(
      <div key={note.id}>
        <b className={'green-text'}>{ note.body }</b> - <i>Posted by { note.support_agent }</i>
      </div>
    );
  });

  return(
    <>
      { arr }
    </>
  );
};

const Patient = ({ patient }) => {

  return (
    <>
      <div>
        {patient.id ? (
          <>
            <Row style={{ paddingLeft: "16px" }}>
              <Col xs={12}>
                <span id="from">wellPORTAL Patient</span>
                <br />
                <span style={{ fontSize: "19px" }}>
                  <b>
                    {patient.url ? (
                      <>
                        <Link
                          to={{ pathname: patient.url }}
                          className="link"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {patient.name}
                          <IoMdOpen id="document-icon" />{" "}
                        </Link>
                      </>
                    ) : (
                      <>{patient.name}</>
                    )}
                  </b>{" "}
                </span>
                <a href={`/physicians/tasks?&status=&search=uid:${ patient.uid }`} target='_blank' className={'m-l-lg btn blue-btn-filled'}>
                  <i className={'fa fa-list'}></i> View All Tasks
                </a>
                <a href={`/physicians/api/tasks/patient_communication?patient_uid=${ patient.uid }`} target='_blank' className={'m-l-lg btn blue-btn-filled'}>
                  <i className={'fa fa-envelope'}></i> Open Patient Communication
                </a>
                <br />

                <span className="ml5">
                  {patient.member_id && <> Member ID: {patient.member_id}</>}{" "}
                </span>
                <span className="ml5">
                  {patient.consented_to_text_messages == true ? (
                    <MdCheckCircle className="patient-check" />
                  ) : (
                    <MdCancel className="patient-close" />
                  )}
                  <b>Consented to Texts </b>
                  {patient.has_account == true ? (
                    <>
                      <MdCheckCircle className="patient-check" />
                      <b>Has account </b>
                    </>
                  ) : (
                    <>
                      {" "}
                      <MdCancel className="patient-close" />
                      <b>Has no account </b>
                    </>
                  )}
                  <b>
                    {patient.established == true ? (
                      <>
                        <MdCheckCircle className="patient-check" /> wellPORTAL Established
                      </>
                    ) : (
                      <>
                        <MdCancel className="patient-close" />
                        Not wellPORTAL Established
                      </>
                    )}{" "}
                  </b>
                  <b>
                    {patient.onboarded == true ? (
                      <>
                        <MdCheckCircle className="patient-check" /> Onboarded
                      </>
                    ) : (
                      <>
                        <MdCancel className="patient-close" />
                        Not Onboarded
                      </>
                    )}{" "}
                  </b>
                  <b>
                    {patient.eligible == true ? (
                      <>
                        <MdCheckCircle className="patient-check" />
                        Eligible
                      </>
                    ) : (
                      <>
                        <MdCancel className="patient-close" />
                        Not Eligible
                      </>
                    )}
                  </b>
                  {patient.out_of_area == true ? (
                    <>
                      <b>
                        {" "}
                        (<i className="geen-text fa fa-map-marker-exclamation patient-close" />
                        Out of Area)
                      </b>
                    </>
                  ) : (
                    <>
                      <b>
                        {" "}
                        (<i className="geen-text fa fa-map-marker-alt patient-check" />
                        In Area)
                      </b>
                    </>
                  )}{" "}
                </span>
                <div style={{ fontSize: "16px", margin: "8px 0 4px -8px" }}>
                  <span className="i-flex">
                    <MdCake className="label-icon" />
                    {patient.birth_date}
                  </span>


                  {patient.phone && (<>
                    <BsFillTelephoneFill className="label-icon" />
                    <PhoneCallButton phoneNumber={patient.phone} />
                  </>)}
                  {patient.email && (
                    <>
                      {" "}
                      <span className="i-flex">
                        <MdOutlineAlternateEmail className="label-icon" />
                        {patient.email}
                      </span>
                    </>
                  )}
                  <span className="i-flex">
                    <FaHome className="label-icon" />
                    {patient.address_line1 && patient.address_line1}
                    {patient.address_line2 && patient.address_line2}
                    {patient.city && ", " + patient.city}
                    {patient.state && ", " + patient.state} {patient.zip_code && patient.zip_code}
                  </span>
                  <br />
                  <span>
                    {" "}
                    Health Plan:
                    <b> {patient.health_plan} </b>
                    Plan Sponsor: <b> {patient.plan_sponsor} </b>
                    Program: <b>{patient.program} </b>
                    <br />
                    Elected PCP: <b> {patient.pcp} </b>
                    {patient.pcp_practice && patient.pcp_practice.id && (
                      <>
                        PCP Practice: <b>{patient.pcp_practice.name} </b>
                        {patient.pcp_practice.phone_number && (
                          <>
                            Phone: <b>{patient.pcp_practice.phone_number} </b>
                          </>
                        )}
                      </>
                    )}
                    <br />
                    Registration Origin: <b>{patient.registration_origin} </b>
                    <br />
                    Registered On: <b>{patient.registered_on} </b>

                  </span>
                  <br />
                </div>
              </Col>
              <Col xs={12} className="pt bt">
                <label>Patient Notes:</label>
                { patient.patient_notes && (<PatientNotesContainer patientNotes={patient.patient_notes} />) }
              </Col>
            </Row>
          </>
        ) : null}{" "}
      </div>
    </>
  );
};
export default Patient;
